import { MinusIcon } from '@heroicons/react/20/solid';
import { twMerge } from 'tailwind-merge';

type Props = {
  value: string | number | null | undefined;
  className?: string;
  suffix?: string;
  prefix?: string;
};

export function ValueOrDash({
  value,
  className,
  suffix = '',
  prefix = '',
}: Props): React.ReactNode {
  if (!value) {
    return <MinusIcon className={twMerge('text-zinc-800/30  h-4 w-4', className)} />;
  }

  return (
    <div>
      {prefix}
      {value}
      {suffix}
    </div>
  );
}
